import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const LinkContainer = styled(Link)`
    text-decoration: none;
    max-height: 80px;

`

export const Button = styled.button`
    height: 80px;
    width: 250px;

    display: flex;
    justify-content: center;
    align-items: center;
    gap:5px;

    cursor: pointer;

    font-weight: 500;
    font-size: 1em;
    letter-spacing: .03em;
    text-transform: uppercase;
    text-decoration: none;

    color: #FFF;
    background-color: #025940;

    border: 0px;
    border-radius: 15px;
    &:hover{
        background-color: #138356;
    }
`

export const ButtonInsideContainerIcon = styled.div`
    display:flex;
    justify-content: end;
    width:15%
`

export const ButtonInsideContainerText = styled.div`
    display:flex;
    justify-content: start;
    text-align: initial;
    width:180px;
`

export const ButtonInsideHiddenContainer = styled.div`
    width: 10%;
    visibility: hidden;
`
